import { render, staticRenderFns } from "./AxonPixel.vue?vue&type=template&id=1ae0df2c&"
import script from "./AxonPixel.vue?vue&type=script&lang=js&"
export * from "./AxonPixel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports